// extracted by mini-css-extract-plugin
export default {"upload":"m3ePS3ZhAQjmoO0HRnRb","uploadButton":"NTdmKFv5Zcol3FJrtiYH"};